export default __webpack_public_path__ + "static/media/6.1a2344ee.png";